import { render, staticRenderFns } from "./HeaderImports.vue?vue&type=template&id=c4a58e7e&scoped=true"
import script from "./HeaderImports.vue?vue&type=script&lang=js"
export * from "./HeaderImports.vue?vue&type=script&lang=js"
import style0 from "./HeaderImports.vue?vue&type=style&index=0&id=c4a58e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a58e7e",
  null
  
)

export default component.exports